import lottie from 'lottie-web';
import { forEach } from '@mindkomm/utils';

export default function animation() {
  forEach(document.querySelectorAll('.lottie'), function(el) {
    var url = el.getAttribute('data-lottie-url');

    if (!url) {
      return;
    }

    lottie.loadAnimation({
      container: el,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: url
    });
  });
}
